exports.strings = {
    // App.js
    "accept": "Accept",
    "acceptedCookieConsent": "Accepted cookie consent",
    "accessCodeIsInvalid": "Access code is invalid",
    "acquiring": "Acquiring...",
    "belowIsLinkRequested": "Below is the link you recently requested. Please click it using a mobile or tablet device to continue your quote/claim:",
    "checkYourEmail": "Please check your email/text messaging app for a message with the link to continue.",
    "cookiesMessage": "We use cookies to ensure that we give you the best experience. If you continue to use this application, you consent to the use of cookies.",
    "decline": "Decline",
    "declineCookieConsent": "Declined cookie consent",
    "declinedConsentMessage": "You have declined the use of cookies and will not be able to continue. If this was done in error, please clear your cookies and you will be prompted to accept.",
    "enteredDataWillBeLost": "If you leave this page, data entered and photos may be lost. Are you sure you want to leave the page?",
    "errorLoggingOut": "Error logging out: %s",
    "filesBeingUploadedInBackground": "Files are currently being uploaded in the background. If you leave the page the upload will be terminated and some files may be lost. Are you sure you want to leave the page?",
    "filesFailedToUpload": "Some files failed to upload. Please check your internet connection or find a more reliable connection and retry from the beginning.",
    "invalidPhoneEmail": "Invalid phone number or email format \"%s \"",
    "invalidStateInClientRequest": "Invalid state in client request: %s",
    "locationCaptureNotRequired": "Location capture not required for this questionSet",
    "locationPermissionDenied": "Unable to retrieve location because permission was denied: %s",
    "locationPositionUnavailable": "Unable to retrieve location because position was unavailable: %s",
    "locationServicesNotAvailable": "Unable to retrieve location because location services are unavailable",
    "locationTimeout": "Unable to retrieve location because of timeout: %s",
    "locationUnavailable": "Unable to retrieve location: %s",
    "loggedIn": "Logged in",
    "loggedOut": "Logged out",
    "needsClientRequestToRun": "This workflow cannot be run in this context without a request.",
    "positionImproved": "Position Improved: %s %s %s",
    "previousWorkflowSessionIdNotFound": "Previous workflow session id not found in cookie. Creating new workflow session.",
    "processing": "Processing...",
    "qsCreatingNewWorkflowSession": "QuestionSet in cookie does not match one found on server. Creating new workflow session.",
    "recordNotFound": "Record not found: %s",
    "resetCookies": "Reset Cookies",
    "restartFromBeginning": "Restart from Beginning",
    "resumingSession": "Resuming previously started session...",
    "resumingWorkflowSession": "Resuming workflow session found on server.",
    "startYourApplication": "Start Your Application",
    "suppliedURLInvalid": "The supplied URL is invalid.",
    "textingLink": "Texting link: %s",
    "unableToDeleteRecord": "Unable to delete record %s",
    "wsIdCreatingNewWorkflowSession": "Workflow session id in cookie not found on server. Creating new workflow session.",
    "yourWebApplicationLink": "Your Web Application Link",

    // location accuracies
    "locationAccuracy": "Location Accuracy",
    "acceptable": "Acceptable",
    "fair": "Fair",
    "good": "Good",
    "great": "Great",
    "outstanding": "Outstanding",
    "poor": "Poor",

    // questionAssignment.js
    "invalidPathForField": "Invalid path for field: %s",
    "invalidUserDataUrlParamFormat": "Invalid user data url parameter format: %s",

    // questionStates.js
    "recordAVideo": "Record a Video",
    "takeAPicture": "Take a Picture",
    "takeAPictureOrVideo": "Take a Picture/Video",

    // serverApi.js
    "fileUploadFailedRetryLater": "A failure occured while uploading a file. Please retry this application later.",
    "dataUploadFailed": "Data upload failed",
    "imageNotAddedToMetadata": "Image item not added to metadata. Was unable to calculate fingerprint.",
    "inProgressNotComplete": "In progress (not complete)",
    "mediaItemNotAddedToMetadata": "Media item not added to metadata.",
    "mediaMetadataFailedToUpload": "Media metadata failed to upload.",
    "mediaNotAddedToMetadata": "Media item not added to metadata. Was unable to calculate fingerprint.",
    "recordCreationFailed": "Record creation failed: %s",

    // AttestivMediaAnalysis.js
    "documentTypeNotSupported": "This type of document is not currently supported. Please use a supported coverage page.",
    "ensureOriginalPhoto": "Please ensure that you are uploading an original photo.",
    "retakePhoto": "Please retake the photo from a different angle.",

    // reducers.js
    "action": "Action: %s",
    "unknownAction": "Unknown action: %s",

    // QuestionContainer.js
    "noAnalysisModel": "No analysis model named %s",
    "provideValidValue": "Please provide a valid value/properly formatted value",
    "unknownQuestionType": "Unknown question type %s for question %s",

    // Summary.js
    "assetDataUploadFailed": "Asset data upload failed",
    "connecting": "Connecting...",
    "fileRemainingToUpload": " file remaining to complete upload",
    "filesRemainingToUpload": " files remaining to complete upload",
    "recordUpdateFailed": "Record update failed: %s",
    "reviewAndSubmit": "Review and Submit",
    "submissionBlocked": "Submission has been blocked for security reasons.",
    "submit": "Submit",
    "support": "Report an Issue",
    "supportPhoneNumber": "Support: ",
    "termsOfService": "Terms of Service",
    "termsOfServiceURL": "https://www.attestiv.com/legal/terms-of-service",
    "unableToConnectToServer": "Unable to connect to server",
    "unknownLocation": "Unknown",
    "verificationMessage": "I verify that all the information I have provided is true and correct to the best of my knowledge. I also agree to the",
    "waitingForUploadToComplete": "Waiting for file uploads to complete...",

    // Complete.js
    "complete": "Complete",

    // ExternalCall.js
    "timeoutErrorCode": "Timeout error code: %s",

    // components/app folder
    "cameraOrMobileDeviceRequired": "This application requires a camera on a mobile phone or tablet device configured for mobile web pages.",
    "chromeBrowserMessage": "The Chrome/Chromium browser you are using is not supported for this application on iOS devices. Please use the Safari browser on iOS.",
    "desktopMessage": "This web application must be accessed from a mobile device. Please use a mobile device to access it or if you would like to send a link for this web application to your mobile device please follow these instructions:",
    "desktopMessageLine1": "1) Enter your mobile number or email address in the box below to send a link to your mobile device.",
    "desktopMessageLine2": "2) Open the link on your mobile device and follow the easy steps (there is no app or download required).",
    "geolocationMessage": "This application requires location services which are not available. Please enable location services and refresh this page to continue.",
    "laptopOrDesktopBrowser": "This application requires a laptop or desktop browser to run.",
    "mobileMessageLine1": "1) Please enter an email address in the box below to receive a link on your laptop or desktop.",
    "mobileMessageLine2": "2) Open the link on your laptop or desktop and follow the easy steps (there is no app or download required).",

    // BarcodeScanner.js
    "loadingScanner": "Loading Scanner...",

    // CaptureCamera.js
    "mediaCaptured": "Media Successfully Captured",
    "tooManyInputFiles": "Please select only 1 file at a time to drop in the box below",

    // buttons folder
    "backButtonText": "BACK",
    "nextButtonText": "NEXT",

    // forms folder
    "required": "Required",

    // serviceWorker.js
    "serviceWorkerInfo": "This web app is being served cache-first by a service worker. To learn more, visit http://bit.ly/CRA-PWA"
};
